import React from 'react';
import { ISVGType } from './SVGType';

const LogoutSVG = (props: ISVGType) => {
  const { width = 18, height = 18, color = "#E75249" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.22932 5.71172C3.8388 5.32119 3.20563 5.32119 2.81511 5.71172L0.292924 8.2339C0.105388 8.42144 3.09944e-05 8.67579 3.09944e-05 8.94101C3.09944e-05 9.20622 0.105388 9.46058 0.292925 9.64811L2.81511 12.1703C3.20563 12.5608 3.8388 12.5608 4.22932 12.1703C4.61985 11.7798 4.61985 11.1466 4.22932 10.7561L2.41425 8.94101L4.22932 7.12593C4.61985 6.73541 4.61985 6.10224 4.22932 5.71172Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0886 8.94104C12.0886 8.38876 11.6409 7.94104 11.0886 7.94104H1.06886C0.516577 7.94104 0.068861 8.38876 0.068861 8.94104C0.068861 9.49332 0.516577 9.94104 1.06886 9.94104H11.0886C11.6409 9.94104 12.0886 9.49332 12.0886 8.94104Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0034 3.81864C15.2148 4.96933 16 6.67 16 8.88183C16 11.0937 15.2148 12.7943 14.0034 13.945C12.7841 15.1032 11.0697 15.7637 9.11818 15.7637C8.5659 15.7637 8.11818 16.2114 8.11818 16.7637C8.11818 17.3159 8.5659 17.7637 9.11818 17.7637C11.5214 17.7637 13.7479 16.9462 15.3808 15.3951C17.0217 13.8364 18 11.5961 18 8.88183C18 6.16751 17.0217 3.92727 15.3808 2.36858C13.7479 0.817423 11.5214 0 9.11818 0C8.5659 0 8.11818 0.447715 8.11818 1C8.11818 1.55228 8.5659 2 9.11818 2C11.0697 2 12.7841 2.66042 14.0034 3.81864Z"
        fill={color}
      />
    </svg>
  );
};

export default LogoutSVG;
